import { Link } from 'react-router';
import { Icon } from '../atoms/Icon';
import PHTile from '../atoms/PHTile';

const HERO_TILES = [
  { l: 'product · flux 1.1',    k: 'image', f: 'rgba(255,126,103,.45)', t: 'rgba(255,77,141,.25)',  r: 0.85 },
  { l: 'portrait · gpt image',  k: 'image', f: 'rgba(255,77,141,.35)',  t: 'rgba(167,139,250,.20)', r: 1.10 },
  { l: 'cinematic · veo 3',     k: 'video', f: 'rgba(99,102,241,.45)',  t: 'rgba(255,126,103,.20)', r: 1.45, d: '0:08' },
  { l: 'ui mock · nano banana', k: 'image', f: 'rgba(167,139,250,.40)', t: 'rgba(99,102,241,.20)',  r: 0.78 },
  { l: 'landscape · sdxl',      k: 'image', f: 'rgba(255,77,141,.40)',  t: 'rgba(255,126,103,.20)', r: 1.55 },
  { l: 'animation · kling 3',   k: 'video', f: 'rgba(99,102,241,.40)',  t: 'rgba(167,139,250,.25)', r: 0.95, d: '0:05' },
  { l: 'logotype · flux ultra', k: 'image', f: 'rgba(255,126,103,.40)', t: 'rgba(255,77,141,.15)',  r: 1.30 },
  { l: 'macro · seedance',      k: 'image', f: 'rgba(16,185,129,.30)',  t: 'rgba(99,102,241,.20)',  r: 1.05 },
  { l: 'fashion · wan 2.7',     k: 'image', f: 'rgba(255,77,141,.45)',  t: 'rgba(167,139,250,.25)', r: 0.82 },
  { l: 'b-roll · luma ray 2',   k: 'video', f: 'rgba(99,102,241,.50)',  t: 'rgba(255,77,141,.25)',  r: 1.60, d: '0:12' },
  { l: 'character · juggernaut',k: 'image', f: 'rgba(255,126,103,.45)', t: 'rgba(255,77,141,.25)',  r: 1.00 },
  { l: 'logo · gpt image 2',    k: 'image', f: 'rgba(167,139,250,.45)', t: 'rgba(255,77,141,.20)',  r: 0.95 },
];

function HeroMosaic() {
  const cols = [[], [], [], []];
  HERO_TILES.forEach((t, i) => cols[i % 4].push(t));
  return (
    <div className="mosaic-mask" style={{ marginTop: 56, position: 'relative' }}>
      <div className="hero-mosaic-grid" style={{ display: 'grid', gap: 14, gridTemplateColumns: 'repeat(4, minmax(0, 1fr))' }}>
        {cols.map((c, ci) => (
          <div key={ci} className="col gap-3" style={{ transform: ci % 2 ? 'translateY(28px)' : 'none' }}>
            {c.map((t, ti) => (
              <PHTile key={ti} label={t.l} kind={t.k} from={t.f} to={t.t} ratio={t.r} dur={t.d} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Hero({ stats }) {
  return (
    <section style={{ paddingTop: 72, paddingBottom: 32 }}>
      <div className="container" style={{ position: 'relative' }}>
        <div className="chip" style={{ marginBottom: 28 }}>
          <span style={{ color: '#FFC2B5' }}>✦</span>
          <span style={{ color: 'var(--text-2)' }}>50+ frontier models · Images, Video &amp; Text</span>
        </div>

        <h1 className="display" style={{ maxWidth: '14ch' }}>
          Every AI model.<br/>
          <span className="grad-text">One platform.</span>
        </h1>

        <p className="lede" style={{ marginTop: 28, maxWidth: '56ch' }}>
          Generate images, videos, and text with the world&rsquo;s best AI models.
          Top up once. No subscriptions. No limits.
        </p>

        <div className="row gap-3" style={{ marginTop: 36, flexWrap: 'wrap' }}>
          <Link className="btn btn-primary btn-lg" to="/register">
            Start creating free <Icon.arrow size={14}/>
          </Link>
          <a className="btn btn-ghost btn-lg" href="#api">View API docs</a>
        </div>

        <div style={{ marginTop: 56, display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0,1fr))', gap: 24, maxWidth: 720 }}>
          {stats.map((s, i) => (
            <div key={i} className="col">
              <div style={{ fontSize: 28, fontWeight: 700, letterSpacing: '-0.02em' }}>{s.v}</div>
              <div style={{ fontSize: 13, color: 'var(--text-3)', marginTop: 4 }}>{s.l}</div>
            </div>
          ))}
        </div>

        <HeroMosaic />
      </div>
    </section>
  );
}
